import {Component, forwardRef, inject, Input, OnInit} from '@angular/core';

import {FieldParameters} from "../../core/definitions/field-parameters";
import {ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule} from "@angular/forms";
import {MatRadioModule} from "@angular/material/radio";
import {InlineViewService} from "../../core/inline-view.service";
import {FieldValueService} from "../../core/field-value.service";
import {findJoinDisposeFormControl, syncJoinDisposeFormControl, updateJoinDisposeLock} from "../../operations/join-dispose-preference";

@Component({
    selector: 'app-edit-field-radio-inline-array',
    imports: [MatRadioModule, ReactiveFormsModule],
    templateUrl: './edit-field-radio-inline-array.component.html',
    styleUrl: './edit-field-radio-inline-array.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => EditFieldRadioInlineArrayComponent)
        }
    ]
})
export class EditFieldRadioInlineArrayComponent implements OnInit, ControlValueAccessor {
  // Injections
  private readonly fieldValueService: FieldValueService = inject(FieldValueService);
  private readonly inlineViewService: InlineViewService = inject(InlineViewService);

  @Input() fieldParameters: FieldParameters;
  @Input() formControlName: string;
  radioFieldName: string;
  radioItems: any[] = [];
  private lastItem = null;

  ngOnInit(): void {
    const uniqueProps = this.fieldParameters.field.inline.unique_props
    if (!uniqueProps) {
      throw new Error('Unique props required for inline radio field');
    }
    this.radioFieldName = uniqueProps[0];
    this.radioItems = this.fieldParameters.object[this.fieldParameters.field.name];
    this.lastItem = this.radioItems.find(item => item[this.radioFieldName]) || null;
    this.setItemView().then();
  }

  async setItemView() {
    for (const radioItem of this.radioItems) {
      radioItem.$$view = await this.inlineViewService.generateInlineViewString(radioItem);
    }
  }

  setSelected(item: any) {
    if (this.lastItem) {
      this.setRadioItemValue(this.lastItem, false);
    }
    this.setRadioItemValue(item, true)
    this.lastItem = item;
    this.fieldValueService.getControl(this.fieldParameters, this.fieldParameters.field.name).markAsDirty()
    if (this.radioFieldName === 'join_item_selected') {
      const joinModel = this.fieldParameters.object;
      const objectType = joinModel?.object_type
        || this.fieldParameters.sectionsContainer?.rootObject?.object_type;
      updateJoinDisposeLock(joinModel, objectType);
      syncJoinDisposeFormControl(
        joinModel,
        findJoinDisposeFormControl(this.fieldParameters.sectionsContainer?.formGroup, joinModel));
    }
  }

  private setRadioItemValue(item: any, value: boolean) {
    item[this.radioFieldName] = value;
  }

  registerOnChange(/*fn: any*/): void {
    // N/A
  }

  registerOnTouched(/*fn: any*/): void {
    // N/A
  }

  writeValue(/*obj: any*/): void {
    // N/A
  }

}
